// import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import CircularProgress from "@mui/material/CircularProgress";

export const Loading = () => {
  return (
    // <Box
    //   direction="row"
    //   justifyContent="center"
    //   alignItems="center"
    //   sx={{ height: "100%" }}
    // >
    //   <CircularProgress />
    // </Box>
    // <Typography variant="h6">Authentication in progress...</Typography>
    <Stack
      direction="row"
      sx={{
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
      }}
    >
      <CircularProgress />
    </Stack>
  );
};
